// import de dependencia
import 'modules/bootstrap/dist/css/bootstrap-reboot.css'
import 'modules/bootstrap/dist/css/bootstrap-grid.min.css'

// override de styles
import './override.scss'
